import React from 'react';
import { Link } from 'react-router-dom';
import { Menu as AntdMenu, Tooltip } from 'antd';
import { ExternalAuthContext } from 'contexts';

import { featureEnabled } from 'utils';
import Icon from '../../Icon';
import { StyledMenu } from '../StyledComponents';
import { StyledMenuProps } from './types';

const RetsMenu: React.FC<StyledMenuProps> = ({
  selectedKey,
  disableToolTip,
  getIconColor,
}) => {
  const {
    auth: { hasFeature, retsId, listing, hasBookedShowing },
  } = React.useContext(ExternalAuthContext);

  const pageName = featureEnabled('propertyNotificationsRevampFeature', 1)
    ? 'Property Notifications'
    : 'Property Updates';

  const isListingUnclaimed = React.useMemo(
    () => Boolean(listing?.isUnclaimed),
    [listing],
  );

  const tooltips = React.useMemo<{
    showing: string | null;
    offer: string | null;
  }>(() => {
    if (!disableToolTip) {
      if (isListingUnclaimed) {
        return {
          showing:
            'You cannot Book a Showing as this listing is not represented by BrokerBay.',
          offer:
            'You cannot Register an Offer as this listing is not represented by BrokerBay.',
        };
      }
      return { showing: 'Showings', offer: 'Register Offer' };
    }
    return { showing: null, offer: null };
  }, [disableToolTip, isListingUnclaimed]);

  return (
    <StyledMenu
      mode="inline"
      selectedKeys={[selectedKey]}
      $hasSupraRebrandingFeature={featureEnabled('supraRebrandingFeature', 1)}
    >
      <AntdMenu.Item
        icon={<Icon type="home" color={getIconColor('0')} />}
        key="0"
        title={disableToolTip ? null : 'View Listing'}
      >
        <Link to={`/rets/${retsId}/listing`}>
          <span>View Listing</span>
        </Link>
      </AntdMenu.Item>
      <AntdMenu.Item
        icon={<Icon type="appointment" color={getIconColor('1')} />}
        key="1"
        title={tooltips.showing}
        disabled={isListingUnclaimed}
      >
        <Link to={`/rets/${retsId}/appointments/book`}>
          <span>Showings</span>
        </Link>
      </AntdMenu.Item>
      {hasFeature('OFFERS') && (
        <AntdMenu.Item
          icon={<Icon type="fileText" color={getIconColor('2')} />}
          key="2"
          title={tooltips.offer}
          disabled={isListingUnclaimed}
        >
          <Link to={`/rets/${retsId}/appointments/offer`}>
            <span>Register Offer</span>
          </Link>
        </AntdMenu.Item>
      )}
      <AntdMenu.Item
        icon={<Icon type="bell" color={getIconColor('3')} />}
        key="3"
        title={disableToolTip ? null : pageName}
        disabled={
          !hasBookedShowing &&
          !featureEnabled('propertyNotificationsRevampFeature', 1)
        }
      >
        <Tooltip
          title={
            !hasBookedShowing &&
            !featureEnabled('propertyNotificationsRevampFeature', 1)
              ? 'Book a showing on the property to receive updates including registered offers, property announcements, and feedback reminders'
              : null
          }
          placement="right"
        >
          <div>
            <Link to={`/rets/${retsId}/appointments/updates`}>
              <span>{pageName}</span>
            </Link>
          </div>
        </Tooltip>
      </AntdMenu.Item>
    </StyledMenu>
  );
};

export default RetsMenu;
